import React, {Component} from "react";

import Login from './LoginView'
import {LoginService} from "../../service/login/LoginService";
import {CHANGE_PASSWORD_ROUTE, MFA_ROUTE} from "../../utils/constants/RoutesConstants";
import {ConfigService} from "../../service/config/ConfigService";

export default class LoginContainer extends Component {
    constructor(props) {
        super(props);

        this.loginService = new LoginService();
        this.configService = new ConfigService();

        this.state = {
            isLoading: false,
            version: '',
            token: '',
            username: '',
            password: '',
            disabledLogin: true,
        }

        this.signUp = this.signUp.bind(this);
        this.onChangeRecaptcha = this.onChangeRecaptcha.bind(this);

        this.getBusinessVersion = this.getBusinessVersion.bind(this);
        this.getReCaptchaToken = this.getReCaptchaToken.bind(this);


    }

    componentDidMount() {
        this.getBusinessVersion();
        this.getReCaptchaToken();
    }

    getBusinessVersion() {
        this.setState({
            version: this.configService.getBusinessVersion(),
        });
    }

    getReCaptchaToken() {
        this.setState({
            token: this.configService.getReCaptchaToken(),
        });
    }

    updateUsername = (event) => {
        this.setState({username: event.target.value})
    }

    updatePassword = (event) => {
        this.setState({password: event.target.value})
    }

    onChangeRecaptcha(value) {
        this.setState({
            disabledLogin: value == null,
        });
    }

    signUp(event) {
        event.preventDefault();
        this.loginService.singUp(this.state.username, this.state.password).then(
            (data) => {
                if (data.screen === "" || data.screen === "NOTIFICATION") {
                    localStorage.setItem("username", data.username);
                    localStorage.setItem("institution", data.shortName);
                    this.setToken(data.accessToken, data.refreshToken);
                    localStorage.setItem("menu", data.menu);
                    localStorage.setItem("institutionId", data.institutionId);
                    localStorage.setItem("notificationMessage", data.screen === "NOTIFICATION" ? "notificationMessage" : "");
                    this.props.history.push("/app");
                } else if (data.screen === "ERROR") {
                    alert(data.message);
                } else if (data.screen === "MFA") {
                    localStorage.setItem("username", data.username);
                    localStorage.setItem("qrUrlAuth", data.qrUrlAuth);
                    this.props.history.push({
                        pathname: MFA_ROUTE,
                    });
                } else if (data.screen === "EXPIRED") {
                    alert(data.message);
                    localStorage.setItem("username", data.username);
                    this.props.history.push({
                        pathname: CHANGE_PASSWORD_ROUTE,
                    });
                } else {
                    this.setState({
                        username: '',
                        password: '',
                    });
                }
            });
    }

    setToken(accessToken, refreshToken) {
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
    }

    render() {
        return (
            <div style={{height: "100%", width: "100%"}}>
                {
                    this.state && this.state.token !== '' &&

                    <Login
                        username={this.state.username}
                        password={this.state.password}
                        signUp={this.signUp}
                        updateUsername={this.updateUsername}
                        updatePassword={this.updatePassword}
                        version={this.state.version}
                        token={this.state.token}
                        disabledLogin={this.state.disabledLogin}
                        onChangeRecaptcha={this.onChangeRecaptcha}
                    />
                }
            </div>
        );
    }
}
;